import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

import { Observable } from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import { throwError } from "rxjs";
import { StorageService } from '../services/storage/storage.service';



export class HttpTokenInterceptor implements HttpInterceptor {
  // constructor(private storage: StorageService){}
  // localStorage.getItem("token")
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = req.clone({
            setHeaders: {
                Authorization: localStorage.getItem("token") || ""
            }
        });
        return next.handle(req).pipe(tap((event: HttpResponse<any>)=>{
            if (event instanceof HttpResponse) {
                // do stuff with response if you want
            }
        }),
        catchError((err: HttpErrorResponse) => {
            if ((err.status == 400) || (err.status == 401)) {                         
             
              
            }
            return throwError(err);
  
        
          })
    )
            
    }
}



export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request)
      .catch((response: any) => {
        if (response instanceof HttpErrorResponse && response.status === 401) {
        }
       // this.spinner.hide()

        return throwError(response);
      });
  }
}
